import "./index.scss";
import React from "react";
import { EXPCONFIG_FAST } from "@/constants/point";
import UKPageNothing from "@/components/UKPageNothing";

interface msgProps {
  msg: string;
  expoId?: string;
}
export default function NoData(props: msgProps) {
  return (
    <div className="no-data-wrap" exptag={props?.expoId ? "exp|" + props?.expoId : ""} data-exptag-config={EXPCONFIG_FAST}>
      <div className="no-data-icon-box">
        <UKPageNothing text={props.msg} />
      </div>
    </div>
  );
}
